// Display the undiscounted net unit price using the existing configurator rounding.
// Cart totals still apply TZ to their own aggregate base; never persist this value.
export function priceIncludingTeuerungszuschlag(price, rate) {
  if (price == null || rate == null || !Number.isFinite(Number(price)) || !Number.isFinite(Number(rate))) return null;
  const priceCents = Math.round(Number(price) * 100);
  return (priceCents + Math.round(priceCents * Number(rate) / 100)) / 100;
}

export function projectCompanyId(project, company) {
  return project?.unternehmen_id ?? project?.unternehmen?.id ?? company?.id ?? null;
}
